<template>
  <footer class="footer bg-gray-900 text-white py-16">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <!-- Informationen Section -->
        <div>
          <h3 class="text-xl font-bold mb-4">Informationen</h3>
          <ul class="text-gray-300">
            <li class="mb-2"><a href="#about" class="hover:text-teal-500">Philosophie</a></li>
            <li class="mb-2"><a href="#contactSection" class="hover:text-teal-500">Kontakt</a></li>
          </ul>
        </div>

        <!-- Gesetzliche Informationen Section -->
        <div>
          <h3 class="text-xl font-bold mb-4">Gesetzliche Informationen</h3>
          <ul class="text-gray-300">
            <li class="mb-2"><router-link to="/impressum" class="hover:text-teal-500">Impressum</router-link></li>
            <li class="mb-2"><router-link to="/datenschutz" class="hover:text-teal-500">Datenschutz</router-link></li>
            <li class="mb-2"><router-link to="/widerrufsrecht" class="hover:text-teal-500">Widerrufsrecht</router-link></li>
          </ul>
        </div>

        <!-- Map Section -->
        <div>
          <h3 class="text-xl font-bold mb-4">Ihr findet uns hier:</h3>
          <ul class="text-gray-300 mb-4">
            <li class="mb-2">
              <a
                href="https://g.co/kgs/usi8Cdx"
                target="_blank"
                rel="noopener noreferrer"
                class="hover:text-teal-500 inline-flex items-start gap-2"
              >
                <span class="text-teal-500">→</span>
                Falckensteinstrasse 4, 10997 Berlin
              </a>
            </li>
            <li class="mb-2">
              <a
                href="https://www.google.com/maps/search/?api=1&query=Gr%C3%BCnenbergerstr.%2058%2C%2010245%20Berlin"
                target="_blank"
                rel="noopener noreferrer"
                class="hover:text-teal-500 inline-flex items-start gap-2"
              >
                <span class="text-teal-500">→</span>
                Grünenbergerstr. 58, 10245 Berlin
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Instagram Icon at the bottom center -->
      <div class="flex justify-center mt-8">
        <a href="https://www.instagram.com/classiccoffeebln" target="_blank" rel="noopener noreferrer" class="hover:text-teal-500">
          <img src="@/assets/instagram.svg" alt="Instagram" class="w-6 h-6 text-white hover:text-teal-500" />
        </a>
      </div>

      <div class="text-center mt-6">
        <p>© 2026 CLASSIC - Specialty Coffee. Alle Rechte vorbehalten.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped>
.footer {
  background: #333;
  color: white;
}

img {
  filter: brightness(0) invert(1); /* Macht das SVG-Icon weiß */
}

</style>
